import React, { useCallback, useEffect, useState } from 'react';
import AsyncSelect from '../../components/AsyncSelect';
import { Controller, useFormContext } from "react-hook-form";
import { useCategoryRequest } from '../../hooks/categoryRequest';
import { BasicDataTypes } from '../../types/types';
import { useAppSelector } from '../../hooks';
const debounce = require('lodash.debounce');

interface SelectDataProps {
  error: string | undefined;
}

const CategorySelect: React.FC<SelectDataProps> = ({ error }) => {
  const { control } = useFormContext();
  const { loading } = useAppSelector(state=> state.category)
  const [ searchText, setSearchText ] = useState<string>("");
  const [ resultData, setResultData ] = useState<BasicDataTypes[]>([]);
  const categoryRequest = useCategoryRequest();

  const fetchData = useCallback(async (query: string) => {
    try {
      const response = await categoryRequest({ method: 'GET', data: null, slug: null, query: query });
      const data = response.payload.data;      
      setResultData(data || []);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  }, [categoryRequest]);

  const debouncedFetchData = useCallback(
    debounce((searchQuery: string) => fetchData(searchQuery), 300),
    [fetchData]
  );

  useEffect(() => {
    if (searchText !== "") {
      debouncedFetchData(searchText);
    } else {
      debouncedFetchData(null);
    }
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData, searchText]);

  return (
    <Controller
      name="category"
      control={control}
      render={({ field }) => (
        <AsyncSelect
          selectedOption={field.value || null}
          options={resultData}
          setSelectedOption={field.onChange}
          placeholder="Select Job Category"
          error={error}
          setSearchText={setSearchText}
          loading={loading}
        />
      )}
    />
  );
};

export default React.memo(CategorySelect);
